export default "__VITE_ASSET__D6Hp9kGr__";